<template>
  <div class='container device-item'>
    <div class="row" v-if="recurrentServicesCount() > 1">
      <div class="col-md-3 col-lg-2">Ke službě:</div>
      <div class="col-md-9 col-lg-10" v-if="!devmeta.isNew">
        {{ recurrentServiceDescription(devmeta.assignmentid) }}
      </div>
      <div class="col-md-9 col-lg-10" v-else>
        <div v-for="service in recurrentServicesInternet" :key="service.id">
          <label>
            <input type="radio" name="assign_to" :value="service.id"
              v-model="inputAssignTo"
            >
            {{ recurrentServiceDescription(service.id) }}
          </label>
        </div>
      </div>
    </div>

    <hr class="d-md-none">

    <div class="row">
      <div class="col-md-3 col-lg-2"><nobr>MAC adresa:</nobr></div>
      <div v-if="!isEditing" class="col-md-9 col-lg-10 device-item-highlight">{{ devmeta.mac }}
        <button class="btn btn-outline-primary btn-editmac" v-on:click="startEdit()" v-if="!$store.state.newMacDetected">
          <i class="fa fa-pencil" aria-hidden="true"></i> změnit
        </button>
        <button class="btn btn-primary btn-editmac" v-on:click="startEdit($store.state.newMacDetected)" v-else>
          <i class="fa fa-pencil" aria-hidden="true"></i> změnit na <span class="">{{$store.state.newMacDetected}}</span>
        </button>
      </div>
      <div v-if="isEditing" class="col-md-9 col-lg-10">
        <form @submit.prevent="noOp()">
          <input type="text" ref="mac" name="mac" class="form-control" autocomplete="off"
            v-model="inputMac" placeholder="00:11:22:aa:bb:cc" :disabled="submitPending"
            v-validate="{ rules: { required: true, regex: /^([0-9a-f]{2}[:\- ]?){6}$/i} }"
            v-on:input="editInput()"
            maxlength="17"
            :class="{'is-danger': errors.has('mac') }"
          >
          <button class="btn btn-primary" v-on:click="saveMac()" :disabled="errors.has('mac') || inputMac == '' || (devmeta.isNew && inputAssignTo == 0) || submitPending">
            <span v-if="!submitPending">uložit</span>
            <span v-else><i class="fa fa-spin fa-spinner" aria-hidden="true"></i></span>
          </button>
          <button class="btn btn-outline-danger" v-on:click="abortEdit()" :disabled="submitPending" type="button">
            <i class="fa fa-close" aria-hidden="true"></i> zrušit
          </button>
          <div v-show="errors.has('mac')" class="help is-danger">Vložte prosím platnou MAC adresu koncového zařízení, které se přejete aktivovat v síti Rychlý drát.</div>
        </form>
      </div>
    </div>

    <div class="row" v-if="devmeta.modified_recently">
      <div class="col-lg-12">
        <div class="alert alert-info" role="alert">
          Změněno {{ devmeta.modified_at }}. Změna se projeví během 15 minut.
        </div>
      </div>
    </div>

    <div class="row" v-if="displayError">
      <div class="col-lg-12">
        <div class="alert alert-danger" role="alert">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ displayError }}
        </div>
      </div>
    </div>

    <hr class="d-md-none">

    <div v-if="!devmeta.isNew">
      <div class="row">
        <div class="col-md-3 col-lg-2">
          <nobr>
            <span v-if="publicAddress(devmeta.ip4addr)" class="badge badge-info" style="font-size: 100%;">veřejná</span>
            IP adresa:
          </nobr>
        </div>
        <div class="col-md-3 col-lg-4">
          <span class="device-item-highlight">{{ devmeta.ip4addr }}</span>
          <a v-on:click="showDetails = true" v-show="!showDetails" href="#">&#x25be; podrobnosti ...</a>
          </div>
        <div class="col-md-6">
          <span v-if="publicAddress(devmeta.ip4addr)" class="text-info">
            <span class="d-none d-md-inline">👈</span>
            toto je Vaše veřejná IP adresa
          </span>
        </div>
      </div>
      <div class="row" v-if="devmeta.created_recently">
        <div class="col-lg-12">
          <div class="alert alert-info" role="alert">
            Přidáno {{ devmeta.created_at }}. Zařízení bude aktivní během 15 minut.
          </div>
        </div>
      </div>
      <div v-show="showDetails" class="alert alert-secondary">
        <nobr>Maska podsítě:</nobr>
        <span class="device-item-highlight">{{ devmeta.netmask }}</span>
        <nobr>Výchozí brána:</nobr>
        <span class="device-item-highlight">{{ devmeta.gateway }}</span>
        <nobr>DNS server 1:</nobr>
        <span class="device-item-highlight">{{ devmeta.dns1 }}</span>
        <nobr>DNS server 2:</nobr>
        <span class="device-item-highlight">{{ devmeta.dns2 }}</span>
      </div>

      <div class="row" v-show="devmeta.ip6addr && devmeta.ip6enabled">
        <div class="col-md-3 col-lg-2">
          <hr class="d-md-none">
          <nobr>
            IP adresa
            <span class="badge badge-info" style="font-size: 100%;">v6</span>:
          </nobr>
        </div>
        <div class="col-md-9 col-lg-10 device-item-highlight">{{ devmeta.ip6addr }}</div>
      </div>

      <div class="row" v-show="devmeta.ip6prefix56 && devmeta.ip6enabled">
        <div class="col-md-3 col-lg-2">
          <hr class="d-md-none">
          <nobr>
            IP subnet
            <span class="badge badge-info" style="font-size: 100%;">v6</span>:
          </nobr>
        </div>
        <div class="col-md-4 col-lg-4 device-item-highlight">{{ devmeta.ip6prefix56 }}/56</div>
        <div class="col-md-5 col-lg-6">
          <span class="text-info">máte k dispozici 256 podsítí o velikosti /64</span>
        </div>
      </div>
      <div class="row" v-if="devmeta.ip6prefix56open">
        <div class="col-lg-12">
          <div class="alert alert-warning" role="alert">
            ⚠️ Volitelná služba <b>otevřený přístup do sítě</b> je zapnutá. Všechny Vaše IP adresy v rozsahu {{ devmeta.ip6prefix56 }}/56 jsou plně dostupné z celého světa.
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import NetDeviceResource from '../backend-resources/netdevice-resource'

export default {
  name: 'netdevice',
  data: () => {
    return {
      showDetails: false,
      isEditing: false,
      inputMac: '',
      inputAssignTo: 0,
      submitPending: false,
      displayError: null
    }
  },
  props: [ 'devmeta', 'recurrentServicesInternet' ],
  methods: {
    startEdit (newMac) {
      this.isEditing = true
      this.inputMac = newMac || this.devmeta.mac
      this.focusOnTheDamnField()
    },
    editInput () {
      setTimeout(() => {
        // Tohle je strasnej hack, ale potrebuju spusti kod az _po_ validations
        if (!this.errors.any()) {
          let normalMac = this.normalizeMacAddress(this.inputMac)
          if (this.inputMac !== normalMac) {
            this.inputMac = normalMac
          }
        }
      }, 50)
    },
    noOp () {
    },
    normalizeMacAddress (mac) {
      mac = mac.replace(/[:\- ]/g, '')
      var normalMac = ''
      for (var i = 0; i < 6; i++) {
        normalMac += mac.substr(i * 2, 2) + ':'
      }
      return normalMac.slice(0, -1)
    },
    saveMac () {
      if (this.devmeta.isNew) return this.addMac()
      if (this.inputMac === this.devmeta.mac) {
        this.abortEdit()
        return
      }
      this.submitPending = true
      this.displayError = null
      NetDeviceResource.patch(this.devmeta.id, {mac: this.inputMac}).then(() => {
        this.displayError = null
        this.submitPending = false
        this.isEditing = false
        this.devmeta.mac = this.inputMac
        this.$store.commit('newMacDetected', false)
        this.$emit('reload-nodes')
      }).catch((error) => {
        if (error.response.status === 409) {
          this.displayError = 'Zadaná MAC adresa je již použita'
          if (!error.response.data.mac_is_own) {
            this.displayError += ' u jiného zákazníka'
          }
        } else {
          this.displayError = error.response.status + ' ' + error.response.statusText
        }
        this.submitPending = false
        this.focusOnTheDamnField()
      })
    },
    focusOnTheDamnField () {
      // ... because autofocus doesn't work here
      setTimeout(() => {
        this.$refs.mac.focus()
      }, 100)
    },
    abortEdit () {
      if (!this.devmeta.isNew) {
        this.isEditing = false
      } else {
        this.abortAdd()
      }
      this.displayError = null
    },
    recurrentServicesCount () {
      return this.recurrentServicesInternet == null ? 0 : this.recurrentServicesInternet.length
    },
    recurrentServiceDescription (id) {
      if (this.recurrentServicesInternet == null) return ''
      let si = this.recurrentServicesInternet.filter(function (s) { return s.id === id })[0]
      if (si === undefined) return ''
      return si.service_name + ' - ' + this.human_readable_adr(si)
    },
    human_readable_adr (si) {
      let address = si.adr_note ? (si.adr_note + ', ') : ''
      address += si.adr_ulice ? si.adr_ulice : si.adr_obec
      address += ' ' + si.adr_cislo
      address += ', ' + si.adr_obec
      if (si.adr_cobce && si.adr_cobce !== si.adr_obec) {
        address += ' - ' + si.adr_cobce
      }
      return address
    },
    addMac () {
      this.submitPending = true
      this.displayError = null
      NetDeviceResource.post({ mac: this.inputMac, service_id: this.inputAssignTo }).then((result) => {
        this.displayError = null
        this.submitPending = false
        this.isEditing = false
        if (this.inputMac === this.$store.state.newMacDetected) this.$store.commit('newMacDetected', false)
        this.$emit('reload-nodes')
      }).catch((error) => {
        if (error.response.status === 409) {
          this.displayError = 'Zadaná MAC adresa je již použita'
          if (!error.response.data.mac_is_own) {
            this.displayError += ' u jiného zákazníka'
          }
        } else {
          this.displayError = error.response.status + ' ' + error.response.statusText
        }
        this.submitPending = false
        this.focusOnTheDamnField()
      })
    },
    abortAdd () {
      this.$emit('remove-device-from-view', null)
    },
    publicAddress (ip) {
      if (typeof ip !== 'string') return false
      if (ip.match(/^\d+\.\d+\.\d+\.\d+$/)) return !this.rfc1918Address(ip)
      return false
    },
    rfc1918Address (ip) {
      if (ip.match(/10\.\d+\.\d+\.\d+/)) return true
      if (ip.match(/192\.168\.\d+\.\d+/)) return true
      if (ip.match(/172\.(1[6-9]|2\d|3[01])\.\d+\.\d+/)) return true
      return false
    }
  },
  created: function () {
    if (this.devmeta.isNew) {
      // init in "add" mode
      this.isEditing = true
      this.inputMac = this.devmeta.mac
      this.focusOnTheDamnField()
    }
  },
  beforeUpdate: function () {
    if (this.devmeta.isNew) {
      if (this.recurrentServicesCount() === 1) { // pokud je jen 1 sluzba, vybrat automaticky prvni (radiobuttons se vubec nezobrazujou)
        this.inputAssignTo = this.recurrentServicesInternet[0]['id']
      }
    }
  }
}
</script>

<style scoped>
/* hack pro zobrazeni network-cable-icon s opacitou */
.device-item::before {
  background-image: url(/static/free-icons/network-cable-icon-15497b.png);
  background-repeat: no-repeat;
  opacity: 1;
  background-position: -17px -14px;
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.device-item {
  padding-left: 100px;
  margin-bottom: 40px;
  padding-top: 10px;
  padding-right: 17px;
  min-height: 100px;
  margin-bottom: 20px;
  border-style: solid;
  border-width: 1px;
  border-color: #e7e7e7;
  border-radius: 4px;
  position: relative;
}
@media (max-width: 768px) { /* bigger than md */
  .device-item {
    padding-left: 10px;
  }
  .device-item::before {
  background-position: right top;
  opacity: 0.3;
  }
}

.device-item-highlight {
  color:#538ebe;
  font-weight: bold;
}
.row {
  margin-bottom: 5px;
  justify-content: center;
}
.btn {
  width: 6em;
  height: 30px;
  padding: 0;
  margin-top: -2px;
}
.btn-editmac {
  margin-left: 15px;
  width: auto;
  padding-left: 1em;
  padding-right: 1em;
}
.is-danger {
  border-color: #ff3860;
}
.help {
  display: block;
  font-size: 11px;
  margin-top: 5px;
  color: #ff3860;
  margin-left: -12px;
}
.form-control {
  margin-left: -12px;
  width: 11em;
  display: initial;
  height: 30px;
}
.error-box {
  margin: 10px;
}
.delete-button {
  background-color: white;
  color: red;
  position: absolute;
  top: 10px;
  right: 7px;
}
</style>



// WEBPACK FOOTER //
// NetDevice.vue?4a706bf4